import { toCamelCase } from '@cli-utils/text.js'
import { renderExtractImportsTemplate } from '@next-adapter/templates/renderers/generators/webhook-events/render-extract.js'

export function renderExtract(
  schemaName: string,
  kind: 'entity' | 'single' | 'form',
  label: string,
  events: string[],
  settingsKey?: string
): string {
  const lines = [
    `  schema: '${schemaName}'`,
    `  kind: '${kind}'`,
    `  label: ${JSON.stringify(label)}`,
    `  events: [${events.map((event) => `'${event}'`).join(', ')}]`
  ]
  if (settingsKey) {
    lines.push(`  settingsKey: '${settingsKey}'`)
  }

  return renderExtractImportsTemplate({
    toCamelCase: toCamelCase(schemaName),
    join: lines.join(',\n')
  })
}
